import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Button } from "Components/atoms/Button";
import {
  FieldSearchContentMobile,
  FieldSearchHeaderMobile,
  FieldSearchMobile,
  GuestSelectorModalContent,
  GuestSelectorModalHeader,
  ModalContent,
  IconContent,
  InfoContent,
  ModalBackdrop,
} from "./styles";
import { ReactComponent as CalendarBackSvg } from "assets/svgs/calendar-back.svg";
import { FaArrowLeft } from "react-icons/fa";
import { GuestSelectorModalProps } from "./types";
import { GuestSelectorDropdownMobile } from "../../GuestSelectorDropdown/Mobile";
import { ReactComponent as AdultsSvg } from "assets/svgs/adults.svg";
import { ReactComponent as BabiesSvg } from "assets/svgs/babies.svg";
import { ReactComponent as ChildrenSvg } from "assets/svgs/children.svg";
import { Typography } from "Components/atoms/Typography";
import { theme } from "styles/theme";
import { useGeneralContext } from "shared/contexts/GeneralContext";
import { useSearchContext } from "shared/contexts/SearchContext";

export const Modal: React.FC<GuestSelectorModalProps> = ({
  isVisibleModal,
  onClose,
  headerExtraChildren,
  title,
  description,
  icon,
  children,
}) => {
  const { isHeaderVisible } = useGeneralContext();
  const { searchState, setAdults, setChildren, setBabies } = useSearchContext();

  useEffect(() => {
    if (isVisibleModal) {
      // Bloqueia o scroll da página de fundo
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    } else {
      // Libera o scroll da página de fundo
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, [isVisibleModal]);

  if (!isVisibleModal) return null;

  const handleIsVisible = () => {
    onClose();
  };

  const modalContent = (
    <ModalBackdrop onClick={(e) => e.stopPropagation()}>
      <FieldSearchContentMobile
        isVisible={isVisibleModal}
        isHeaderVisible={isHeaderVisible}
      >
        <FieldSearchHeaderMobile isVisible={isVisibleModal}>
          <Button
            onClick={handleIsVisible}
            icon={<FaArrowLeft />}
            color="white"
            size="ghost"
          />
          <FieldSearchMobile isVisible={isVisibleModal}>
            <GuestSelectorModalHeader>
              {icon && (
                <IconContent>
                  <AdultsSvg style={{ fill: "#FFFFFF" }} />
                </IconContent>
              )}
              <InfoContent>
                {title && (
                  <Typography color={theme.colors.white} variant="h2">
                    {title}
                  </Typography>
                )}
                {description && (
                  <Typography color={theme.colors.white} variant="label">
                    {description}
                  </Typography>
                )}
              </InfoContent>
            </GuestSelectorModalHeader>
          </FieldSearchMobile>
          {headerExtraChildren}
        </FieldSearchHeaderMobile>
        <ModalContent id="ModalContent">{children}</ModalContent>
      </FieldSearchContentMobile>
    </ModalBackdrop>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};
